// Computes the 1-based implementation day for a given deadline relative to the
// implementation start date. Returns null when either date is missing/invalid or
// when the deadline falls before the start date.
//
// dayNumber = floor((deadline − start) / 1 day) + 1
export const getImplementationDay = (
  deadline: string | null | undefined,
  startDate: string | null | undefined,
): number | null => {
  if (!deadline || !startDate) return null;

  const start = new Date(`${startDate.slice(0, 10)}T00:00:00`);
  const due = new Date(`${deadline.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(due.getTime())) return null;

  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const diffDays = Math.floor((due.getTime() - start.getTime()) / MS_PER_DAY);
  if (diffDays < 0) return null;

  return diffDays + 1;
};

// Computes the deadline date (YYYY-MM-DD) for an item given the implementation
// start date and the item's estimated work days (1-based day offset).
//
// deadline = startDate + (workDays − 1) days
// Returns null when either argument is missing/invalid or workDays < 1.
export const getDeadlineDateFromWorkDays = (
  workDays: number | null | undefined,
  startDate: string | null | undefined,
): string | null => {
  if (!workDays || workDays < 1 || !startDate) return null;

  const start = new Date(`${startDate.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(start.getTime())) return null;

  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const deadline = new Date(start.getTime() + (workDays - 1) * MS_PER_DAY);
  const yyyy = deadline.getFullYear();
  const mm = String(deadline.getMonth() + 1).padStart(2, '0');
  const dd = String(deadline.getDate()).padStart(2, '0');
  return `${dd}-${mm}-${yyyy}`;
};
